import Breadcrumb from '../../layout/breadcrumb';
import React, { useState, useEffect, Fragment } from 'react';
import Rating from 'react-rating';
import { Container, Row, Col, Card, CardBody, CardHeader, Button, ButtonGroup, Badge } from 'reactstrap';

import { useGlobalState } from 'state-pool';

import SweetAlert from 'sweetalert2';

import { worker_firstName, worker_lastName } from '../../constant/names';

import Moment from 'react-moment';

import CONTRACT_LIST from '../../contracts/contractList';
import { ASSETS_CDN } from '../../constant/config';

import { EternalBtn } from '../Button';
import { EthernalSVG } from '../utils/EternalIcon';
import { giftAsset } from '../gift-asset';
import { Information } from '../utils/Information';
import useQueue, { revealNFT } from '../../hooks/useQueue';
import worker_placeholder from '../../assets/images/worker_placeholder.png';

const Workers = (props) => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [videoAnimation] = useGlobalState('animateVideo');
  const [userAddress, setUserAddress] = useGlobalState('userAddress');

  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');

  const [spaceshipContract, setSpaceshipContract] = useGlobalState('spaceshipContract');
  const [spaceshipAmount, setSpaceshipAmount] = useGlobalState('spaceshipAmount');

  const [workerContract, setWorkerContract] = useGlobalState('workerContract');
  const [workerAmount, setWorkerAmount] = useGlobalState('workerAmount');

  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [maxWorkers, setMaxWorkers] = useGlobalState('maxWorkers');
  const [minePower, setMinePower] = useGlobalState('MinePower');
  const [mintCost] = useGlobalState('mintCost');
  const [contractCost] = useGlobalState('contractCost');

  const [workerList, setWorkers] = useState(0);
  const [noContractWorkers, setNoContractWorkers] = useState(0);
  const [canMint, setCanMint] = useState(1);

  const [marketplaceContract, setMarketplaceContract] = useGlobalState('marketplaceContract');
  const MARKETPLACE_CONTRACT = CONTRACT_LIST['MARKETPLACE_CONTRACT'];

  const [loaded, setLoaded] = useState(0);
  const [layoutColumns, setLayoutColumns] = useState(3);
  const [open, setOpen] = useState(false);
  const [toggleInformation, setToggleInformation] = useState(false);

  const [pendingRequest, setPendingRequest] = useState(false);

  const [totalMinePower, setTotalMinePower] = useState(false);

  const [claimRewards, setClaimRewards] = useGlobalState('claimRewards');
  const [queueItems, setContracts, shouldUpdate] = useQueue();

  useEffect(() => {
    if (pendingRequest) {
      SweetAlert.fire({
        title: 'Awaiting confirmation',
        html: 'Check MetaMask window for transaction confirmation. <hr> <p>⚠️ Contracting workers 1 by 1 will deduct the <b>$ETERNAL</b> from the <b>pending rewards first</b> and then from your wallet. <br> (30% Tax will be avoided)</p> ',
        icon: 'info',
        showConfirmButton: false,
      });
    } else {
    }
  }, [pendingRequest]);

  useEffect(() => {
    async function initializeWorkers() {
      setContracts({
        contract: workerContract,
        userAddress,
      });
      reloadList();
    }

    if (cryptominesContract != null && loaded === 0) {
      initializeWorkers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workerContract, userAddress]);

  const reloadList = async () => {
    let currentTotalMinePower = 0;
    const workersArray = await cryptominesContract.methods.getMyWorkers().call({ from: userAddress });
    const workers = [];
    let noContractWorker = 0;
    for (const tokenId of workersArray) {
      const workerData = await workerContract.methods.getTokenDetails(tokenId).call({ from: userAddress });
      const transferCooldown = await workerContract.methods.getTokenCooldown(tokenId).call({ from: userAddress });
      const worker = Object.assign({ id: tokenId }, workerData);
      const currentTime = Date.now();
      worker['contractDueDate'] = parseInt(worker['contractDueDate']) * 1000;
      worker['contractDate'] = new Date(worker['contractDueDate']);

      if (parseInt(tokenId) > 150000) {
        worker['season'] = 'workers_s2';
      } else {
        worker['season'] = 'workers';
      }

      let min_range = 0;
      let max_range = 255;
      switch (parseInt(worker['level'])) {
        case 1:
          min_range = 5;
          max_range = 50;
          break;
        case 2:
          min_range = 50;
          max_range = 100;
          break;
        case 3:
          min_range = 100;
          max_range = 150;
          break;
        case 4:
          min_range = 150;
          max_range = 200;
          break;
        case 5:
          min_range = 200;
          max_range = 255;
          break;
      }

      let variantResult = (parseInt(worker['minePower']) - min_range) / (max_range - min_range);

      if (variantResult >= 0 && variantResult <= 0.6) {
        worker['variant'] = 1;
      } else if (variantResult >= 0.61 && variantResult <= 0.94) {
        worker['variant'] = 2;
      } else {
        worker['variant'] = 3;
      }

      if (currentTime >= worker.contractDueDate) {
        worker['needContract'] = true;
        noContractWorker++;
      } else {
        worker['needContract'] = false;
      }

      worker['uid'] = worker['id'] + worker['roll'] + worker['firstName'] + worker['lastName'];

      const TRANSFER_TIME = 0;
      let now = parseInt((Date.now() / 1000).toFixed(0));
      if (transferCooldown > now - TRANSFER_TIME) {
        worker['canTransfer'] = 0;
      } else {
        worker['canTransfer'] = 1;
      }
      worker['transferCooldown'] = (parseInt(transferCooldown) + 0) * 1000;

      const cooldown = 86400;
      const mineTime = parseInt(worker['lastMine']) + cooldown;
      if (mineTime * 1000 <= currentTime) {
        worker['canMine'] = true;
        worker['mineDate'] = new Date();
      } else {
        worker['canMine'] = false;
        worker['mineDate'] = new Date(mineTime * 1000);
      }
      currentTotalMinePower = currentTotalMinePower + parseInt(worker['minePower']);

      workers.push(worker);
    }
    if (workers.length > maxWorkers) {
      setCanMint(0);
    } else {
      setCanMint(1);
    }
    setTotalMinePower(currentTotalMinePower);
    setNoContractWorkers(noContractWorker);
    setWorkers(workers);
    setLoaded(1);
  };

  const reloadData = async () => {
    const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });
    const currentWorkers = await workerContract.methods.balanceOf(userAddress).call({ from: userAddress });
    const currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: userAddress });
    const currentClaimRewards = await cryptominesContract.methods
      .getTokenRewards(userAddress)
      .call({ from: userAddress });

    reloadList();
    setClaimRewards(web3.utils.fromWei(currentClaimRewards, 'ether'));
    setWorkerAmount(currentWorkers);
    setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
    setMinePower(currentMinePower);
  };

  const mintWorker = async () => {
    // SweetAlert.fire({
    //   title: 'In maintenance',
    //   text: 'Know more at your Telegram or Discord.',
    //   icon: 'error',
    // });

    if (parseFloat(stoneAmount) < parseFloat(mintCost)) {
      SweetAlert.fire({
        title: 'Not enough $ETERNAL',
        text: 'Get more $ETERNAL to mint a new NFT.',
        icon: 'error',
      });
    } else {
      try {
        await cryptominesContract.methods.queueMint(0).send({ from: userAddress, value: 400000000000000 });
        window.gtag('event', 'mintWorker', { address: userAddress });
        cryptominesContract
          .getPastEvents('eventMintWorker', { fromBlock: 'latest', toBlock: 'latest', address: [userAddress] })
          .then(async (results) => {
            SweetAlert.fire({
              title: 'Great!',
              text: 'Your box has arrived. 📦',
              icon: 'success',
            });
          });

        reloadData();
        shouldUpdate(Math.random());
      } catch (error) {
        //console.log('error: ', error);
      }
    }
  };

  const burnWorker = async (tokenId) => {
    window.gtag('event', 'burnWorker', { tokenId: tokenId, address: userAddress });
    SweetAlert.fire({
      title: 'Be aware',
      html:
        'Once deleted, you will not be able to recover this NFT. It will be burned forever. 🔥 <br><br> <b>You will receive ' +
        (mintCost * 0.2).toFixed(3) +
        ' ETERNAL per burn. 🤑</b>',
      icon: 'warning',
      confirmButtonText: 'Proceed',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await cryptominesContract.methods.burnWorker(tokenId).send({ from: userAddress });
        reloadData();
        cryptominesContract
          .getPastEvents('eventBurnWorker', { fromBlock: 'latest', toBlock: 'latest', address: [userAddress] })
          .then(async (results) => {
            SweetAlert.fire({
              title: 'Nice!',
              text: 'Your NFT was burned. 😊 ',
              icon: 'success',
            });
          });
      }
    });
  };

  const burnWorkerLevelOne = async (tokenId) => {
    window.gtag('event', 'burnWorkerLeveOne', { tokenId: tokenId, address: userAddress });
    SweetAlert.fire({
      title: 'Be aware',
      html:
        'Once deleted, you will not be able to recover this NFT. It will be burned forever. 🔥 <br><br> <b>You will receive ' +
        (mintCost * 0.2).toFixed(3) +
        ' ETERNAL per burn. 🤑</b>',
      icon: 'warning',
      confirmButtonText: 'Proceed',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await cryptominesContract.methods.burnWorker(tokenId).send({ from: userAddress });
        reloadData();
        cryptominesContract
          .getPastEvents('eventBurnWorker', { fromBlock: 'latest', toBlock: 'latest', address: [userAddress] })
          .then(async (results) => {
            SweetAlert.fire({
              title: 'Nice!',
              text: 'Your NFT was burned. 😊 ',
              icon: 'success',
            });
          });
      }
    });
  };

  const burnWorkerContract = async (tokenId) => {
    window.gtag('event', 'burnWorkerWithContract', { tokenId: tokenId, address: userAddress });
    SweetAlert.fire({
      title: 'Be aware',
      html:
        "Once deleted, you will not be able to recover this NFT. It will be burned forever. 🔥 <br><br> <b class='txt-danger'>You will pay " +
        (mintCost * 0.2).toFixed(3) +
        ' ETERNAL because this worker has an active contract.</b>',
      icon: 'warning',
      confirmButtonText: 'Proceed',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await cryptominesContract.methods.burnWorker(tokenId).send({ from: userAddress });
        reloadData();
        SweetAlert.fire({
          title: 'Nice!',
          text: 'Your NFT was burned. 😊 ',
          icon: 'success',
        });
      }
    });
  };

  const sellWorker = async (tokenId) => {
    window.gtag('event', 'sellWorker', { tokenId: tokenId, address: userAddress });
    SweetAlert.fire({
      title: 'For how much you will <b>SELL</b> this NFT? <br> You will receive 90% of the given price.',
      icon: 'question',
      input: 'text',
      confirmButtonText: 'Proceed',
      footer: '<center><span class="txt-danger">Please double check the amount of $ETERNAL</span></center>',
    }).then(async (result) => {
      if (result.value) {
        const allNFTApproved = await workerContract.methods
          .isApprovedForAll(userAddress, MARKETPLACE_CONTRACT)
          .call({ from: userAddress });
        if (allNFTApproved == false) {
          await workerContract.methods.setApprovalForAll(MARKETPLACE_CONTRACT, true).send({ from: userAddress });
        }

        await marketplaceContract.methods
          .sellNFT(0, tokenId, web3.utils.toWei(result.value, 'ether'))
          .send({ from: userAddress });
        reloadData();
        SweetAlert.fire({
          title: 'Nice!',
          text: 'Your NFT was put in sale. 😊 ',
          icon: 'success',
        });
      }
    });
  };

  const contractWorker = async (tokenId, days) => {
    if (parseFloat(parseFloat(stoneAmount) + parseFloat(claimRewards)) < parseFloat(contractCost * days)) {
      SweetAlert.fire({
        title: 'Not enough $ETERNAL',
        text: 'Get more $ETERNAL to contract your worker.',
        icon: 'error',
      });
    } else {
      window.gtag('event', 'contractWorker', { tokenId: tokenId, days: days, address: userAddress });
      try {
        setPendingRequest(true);
        const response = await cryptominesContract.methods.contractWorker(tokenId, days).send({ from: userAddress });
        //console.log('response: ', response);

        if (response.status === true) {
          reloadData();
          setPendingRequest(false);
        } else {
          setPendingRequest(false);
        }
      } catch (error) {
        SweetAlert.update({
          title: 'Canceled',
          html: 'Your request has been canceled.',
          icon: 'error',
          showConfirmButton: true,
        });
        setPendingRequest(false);
        //console.log('error: ', error);
      }
    }
  };

  const contractAllMyWorkers = async (days) => {
    if (parseFloat(stoneAmount) < parseFloat(contractCost * days * noContractWorkers)) {
      SweetAlert.fire({
        title: 'Not enough $ETERNAL',
        text: 'Get more $ETERNAL to contract yours workers.',
        icon: 'error',
      });
    } else {
      window.gtag('event', 'contractAllWorkers', { days: days, address: userAddress });
      await cryptominesContract.methods.contractAllMyWorkers(days).send({ from: userAddress });
      reloadData();
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent='Workers' title='Workers' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card className='card-absolute'>
              <CardHeader className='bg-secondary'>
                <h3>Workers</h3>
                {/* <button
                  className='toggle-information btn btn-success'
                  onClick={() => setToggleInformation(!toggleInformation)}
                >
                  ?
                </button> */}
              </CardHeader>
              <CardBody>
                <Information section='workers' display={true} />
                <Row>
                  <Col sm='4'>
                    <Card className='o-hidden '>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>MINT Worker</b>
                          </p>
                          <EternalBtn action={mintWorker}>Pay {parseFloat(parseFloat(mintCost).toFixed(3))} ETERNAL </EternalBtn>
                          {!canMint ? (
                            <p className='txt-danger'>
                              Your currently have the max allowed Workers. <br /> Can't go to expeditions with this many
                              Workers
                            </p>
                          ) : (
                            ''
                          )}
                        </center>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col sm='4'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Current Workers</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-warning ml-3'>
                              {workerAmount}/{maxWorkers} Workers
                            </span>
                          </h4>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col sm='4'>
                    <Card className='o-hidden'>
                      <CardBody>
                        <center>
                          <p className='f-w-500 font-roboto f-26'>
                            <b>Current Mine Power</b>
                          </p>
                          <h4 className='f-w-500 mb-0 f-26'>
                            <span className='badge pill-badge-secondary ml-3'>
                              {minePower}/{totalMinePower} MP
                            </span>
                            {totalMinePower >= 1500 ? (
                              <Fragment>
                                <Badge color='primary'>Veteran Guild</Badge>
                              </Fragment>
                            ) : (
                              ''
                            )}
                          </h4>
                        </center>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                {noContractWorkers ? (
                  <Row>
                    <Col sm='12'>
                      <p>
                        Contract <b>{noContractWorkers} workers</b> without contract (Contracting multiples workers will
                        deduct the $ETERNAL from your wallet):{' '}
                      </p>
                      <Button
                        className='btn-pill btn-air-primary'
                        color='primary'
                        onClick={() => contractAllMyWorkers(7)}
                      >
                        {' '}
                        7 Days ({parseFloat((contractCost * 7 * noContractWorkers).toFixed(3))} ETERNAL){' '}
                      </Button>{' '}
                      &nbsp;
                      <Button
                        className='btn-pill btn-air-primary'
                        color='primary'
                        onClick={() => contractAllMyWorkers(15)}
                      >
                        {' '}
                        15 Days ({parseFloat((contractCost * 15 * noContractWorkers).toFixed(3))} ETERNAL){' '}
                      </Button>{' '}
                      &nbsp;
                      <Button
                        className='btn-pill btn-air-primary'
                        color='primary'
                        onClick={() => contractAllMyWorkers(30)}
                      >
                        {' '}
                        30 Days ({parseFloat((contractCost * 30 * noContractWorkers).toFixed(3))} ETERNAL){' '}
                      </Button>
                      <br />
                      <br />
                      <p>
                        💡 Contracting workers 1 by 1 will deduct the $ETERNAL from the pending rewards first and then
                        from your wallet. (30% Tax will be avoided)
                      </p>
                      <p>
                        <span role='img' aria-label='Warning icon'>
                          ⚠️
                        </span>
                        If your claim rewards become 0 the tax timer will restart.
                      </p>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}

                <div>
                  {queueItems >= 1 ? (
                    <>
                      <hr />
                      <h4>Awaiting deployment</h4>
                      <p>Your workers have arrived at your headquarters, they are ready to mine.</p>
                      <Row className='gridRow'>
                        {Array(queueItems)
                          .fill(0)
                          .map((_, index) => {
                            return (
                              <div key={index} className='col-xl-3 col-sm-6 xl-4 col-grid-box'>
                                <Card>
                                  <div className='product-box'>
                                    <div className='product-img'>
                                      {videoAnimation ? (
                                        <video
                                          className='img-fluid '
                                          muted
                                          loop={videoAnimation}
                                          autoPlay={videoAnimation}
                                          poster={`${ASSETS_CDN}/lootbox-placeholder.png`}
                                        >
                                          <source src={`${ASSETS_CDN}/lootbox.mp4`} type='video/mp4' />
                                          <img alt='lootbox workers' src={`${ASSETS_CDN}/lootbox-placeholder.png`} />
                                        </video>
                                      ) : (
                                        <img alt='lootbox workers' src={`${ASSETS_CDN}/lootbox.png`} />
                                      )}
                                    </div>
                                    <div className='product-details'>
                                      <div className=''>
                                        <center>
                                          <Button
                                            variant='primary'
                                            onClick={() => {
                                              revealNFT(cryptominesContract, userAddress, 0).then((response) => {
                                                setTimeout(() => {
                                                  reloadData();
                                                }, 3000);

                                                shouldUpdate(Math.random());
                                                SweetAlert.fire({
                                                  title: 'Nice!',
                                                  text: 'A new worker joined your guild.',
                                                  icon: 'success',
                                                });
                                              });
                                            }}
                                          >
                                            Open Box{' '}
                                            <span role='img' aria-label='box'>
                                              📦
                                            </span>
                                          </Button>
                                        </center>
                                      </div>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            );
                          })}
                      </Row>
                    </>
                  ) : undefined}
                </div>

                <hr />
                <Row className='gridRow'>
                  {workerList
                    ? workerList.map((worker, i) => (
                        <div
                          className={`${
                            layoutColumns === 3 ? 'col-xl-3 col-sm-6 xl-4 col-grid-box' : 'col-xl-' + layoutColumns
                          }`}
                          key={worker.id}
                        >
                          <Card>
                            <div className={`product-box`}>
                              <span className='ribbon'>
                                <b>Unique Id: </b> 0x{worker.uid} <br />
                                <b>Name: </b> {worker_firstName[worker.firstName]} {worker_lastName[worker.lastName]}
                                <br />
                                <b>Transfer Cooldown: </b>{' '}
                                {worker.canTransfer ? 'Available' : 'Available'}
                              </span>

                              {!worker.canMine && (
                                <span className='ribbon ribbon ribbon-vertical-right ribbon-danger'>
                                  <i className='icon-time'></i>
                                </span>
                              )}

                              <div className={`product-img ${worker.season}_up`}>
                                <span className='ribbon ribbon-clip-bottom-right ribbon-primary'>
                                  <b>Worker Rarity:</b>{' '}
                                  <Rating
                                    initialRating={worker.level}
                                    emptySymbol='fa fa-star-o'
                                    fullSymbol='fa fa-star'
                                    readonly={true}
                                  />{' '}
                                  <br />
                                </span>

                                {worker.minePower <= 14 ? (
                                  <span className='ribbon ribbon-clip-bottom ribbon-success'>
                                    <b>Legacy Worker 🥉</b>
                                  </span>
                                ) : (
                                  ''
                                )}

                                {videoAnimation ? (
                                  <video
                                    className='img-fluid'
                                    muted
                                    loop={videoAnimation}
                                    autoPlay={videoAnimation}
                                    poster={`${ASSETS_CDN}/${worker.season}/rank${worker.level}/variant${
                                      worker.variant
                                    }/1.png`}
                                  >
                                    {worker.canMine ? (
                                      <source
                                        src={`${ASSETS_CDN}/${worker.season}/rank${worker.level}/variant${
                                          worker.variant
                                        }/${Math.floor(Math.random() * 4) + 1}.mp4`}
                                        type='video/mp4'
                                      />
                                    ) : (
                                      <source
                                        src={`${ASSETS_CDN}/${worker.season}/rank${worker.level}/variant${worker.variant}/5.mp4`}
                                        type='video/mp4'
                                      />
                                    )}
                                    <img className='img-fluid'
                                      alt='Worker NFT'
                                      src={`${ASSETS_CDN}/${worker.season}/rank${worker.level}/variant${
                                        worker.variant
                                      }/5.png`}
                                    />
                                  </video>
                                ) : (
                                  <img className='img-fluid'
                                    src={`${ASSETS_CDN}/${worker.season}/rank${worker.level}/variant${worker.variant}/5.png`}
                                    alt='Worker NFT'
                                  />
                                )}

                                <div className='product-hover'>
                                  <ul>
                                    <li>
                                      {worker.needContract && worker.level > 1 && (
                                        <Button color='default' onClick={() => burnWorker(worker.id)}>
                                          <i className='icon-trash'></i>
                                        </Button>
                                      )}
                                      {!worker.needContract && worker.level > 1 && (
                                        <Button color='default' onClick={() => burnWorkerContract(worker.id)}>
                                          <i className='icon-trash'></i>
                                        </Button>
                                      )}
                                      {worker.level == 1 && (
                                        <Button color='default' onClick={() => burnWorkerLevelOne(worker.id)}>
                                          <i className='icon-trash'></i>
                                        </Button>
                                      )}
                                    </li>
                                    <li>
                                      <Button
                                        color='default'
                                        onClick={() => giftAsset(worker.id, workerContract, userAddress)}
                                      >
                                        <i className='icon-gift'></i>
                                      </Button>
                                    </li>

                                    <li>
                                      <Button color='default' onClick={() => sellWorker(worker.id)}>
                                        <i className='icon-shopping-cart'></i>
                                      </Button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className={`product-details ${worker.season}_down`}>
                                <div className={`product-price`}>
                                  <center className={`${worker.season}_text`}>{worker.minePower} MP </center>
                                </div>

                                <center>
                                  <hr />

                                  {worker.needContract && (
                                    <div>
                                      <p style={{ marginBottom: 10 }}>Contract Worker</p>
                                      <div>
                                        <ButtonGroup style={{ width: '100%' }}>
                                          <Button
                                            className='btn-pill custom-group-item btn-air-secondary'
                                            color='primary'
                                            onClick={() => contractWorker(worker.id, 7)}
                                          >
                                            <strong>7 Days</strong>
                                            <span className='custom-costs'>
                                              <EthernalSVG />
                                              {parseFloat((contractCost * 7).toFixed(3))}
                                            </span>
                                          </Button>{' '}
                                          <Button
                                            className='btn-pill custom-group-item btn-air-primary'
                                            color='primary'
                                            onClick={() => contractWorker(worker.id, 15)}
                                          >
                                            <strong>15 Days</strong>
                                            <span className='custom-costs'>
                                              <EthernalSVG />
                                              {parseFloat((contractCost * 15).toFixed(3))}
                                            </span>
                                          </Button>{' '}
                                          <Button
                                            className='btn-pill custom-group-item btn-air-primary'
                                            color='primary'
                                            onClick={() => contractWorker(worker.id, 30)}
                                          >
                                            <strong>30 Days</strong>
                                            <span className='custom-costs'>
                                              <EthernalSVG />
                                              {parseFloat((contractCost * 30).toFixed(3))}
                                            </span>
                                          </Button>{' '}
                                        </ButtonGroup>
                                      </div>
                                    </div>
                                  )}

                                  {!worker.needContract && (
                                    <div>
                                      <p>
                                        <b>Contract Expires: </b> <Moment date={worker.contractDate} fromNow />{' '}
                                      </p>
                                      <p>
                                        <b>Can Mine: </b>
                                        {worker.canMine && <span>Now</span>}
                                        {!worker.canMine && <Moment date={worker.mineDate} fromNow />}
                                      </p>
                                    </div>
                                  )}
                                </center>
                              </div>
                            </div>
                          </Card>
                        </div>
                      ))
                    : ''}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Workers;
